import React from 'react';
import { SectionSkeleton, SECTION_SKELETON_VARIANTS } from './SectionSkeleton';

/**
 * GridSkeleton — backward-compatible wrapper.
 *
 * @deprecated Use `<SectionSkeleton variant="grid" />` instead.
 * @param {boolean} isMobile - viewport flag [Optional]
 * @param {string} title - section title [Optional]
 */
export const GridSkeleton = ({ isMobile, title }) => (
  <SectionSkeleton
    variant={SECTION_SKELETON_VARIANTS.grid}
    isMobile={isMobile}
    title={title}
  />
);
